/** @module csi/table/NewWithUpload */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/comm/PostRequest",
	"csi/def",
	"csi/html",
	"csi/service/writerService",
	"csi/table/New",
	"csi/xml"
], function(declare, _, PostRequest, def, html, {submitWriter}, New, xml) {

	return declare(New, {
		/** @property {boolean} bUseResultNodeUrl - set to true to use the URL from the response's result node rather than create one from the client */
		bUseResultNodeUrl: false,

		/**
		 * @override
		 * Create PostRequest to submit file along with any parameters from form fields
		 */
		process: function() {
			var self = this;
			var actionRequest = this.m_action.m_request;
			var fd = this.getFormData();
			var req = new PostRequest(actionRequest.m_module, actionRequest.m_operation);

			if (!this.bUseResultNodeUrl) {
				this.m_urlNode = this.createNewUrl();

				if (!this.m_urlNode) {
					throw new Error('URLCREATE');
				}

				req.addParameter(xml.PROP_URL, this.m_urlNode);
			}

			if (xml.isValidURL(this.m_urlParent)) {
				req.addParameter(xml.PROP_URL_PARENT, this.m_urlParent);
				req.addParameter(xml.PROP_ATTR_PARENT, this.m_idAttrParent);
			}

			_.each(actionRequest.m_parameters, function(p) {
				req.addParameter(p.m_id, p.m_value);
			});

			_.each(fd.getFields(), function(f) {
				if (f.m_typeControl == def.FIELD_FILE) {
					// f.getValue() only returns file name rather than File object
					req.addFiles(html.getInputFileArray(f.m_control), f.idParameter || f.getControlName());
					f.m_bUsed = true;
				} else if (f.idParameter) {
					req.addParameter(f.idParameter, f.getValue());
					f.m_bUsed = true;
				}
			});

			var dfd = req.post().then(function(response) {
				// write any form field values that were not parameters to the initial request
				var w = self.m_writer;

				if (self.bUseResultNodeUrl) {
					var node = response.getResultNode();
					if (node) {
						self.m_urlNode = node.$URL;
					}
				}

				if (self.m_urlNode) {
					self.toWriterFields(self.m_urlNode);
				}

				return w.isChanged() ? submitWriter(w) : response;
			});

			this.waitForPublish(dfd, true);
		}
	});
});
